import {useIntl} from 'react-intl'
import {toast} from 'react-toastify'
import useCancelToken from '../../../../../_gori/hooks/UseCancelToken'
import {useState} from 'react'
import A1BatchService from '../../core/_requests'
import clsx from 'clsx'
import {ModalTemplate} from '../../modals/template'
import {InputTextFormik} from '../../../../../_gori/partials/widgets'
import * as Yup from 'yup'
import UseYupValidate from '../../../../../_gori/hooks/UseYupValidate'
import {useFormik} from 'formik'

type RenameA1BatchProps = {
  id: string
  name: string
  onSuccess?: (newName: string) => void
  onError?: (error: any) => void
  className?: string
  disabled?: boolean
}
export const RenameA1Batch = ({
  id,
  name = '',
  onSuccess,
  onError,
  className,
  disabled,
}: RenameA1BatchProps) => {
  const intl = useIntl()
  const {newCancelToken, isCancel} = useCancelToken()
  const {stringYup} = UseYupValidate()

  const [showModal, setShowModal] = useState(false)

  const validateSchema = Yup.object({
    name: stringYup(255, 'A1_BATCH_NAME'),
  })

  const handleCloseModal = () => {
    setShowModal(false)
  }

  const formik = useFormik({
    initialValues: {name},
    enableReinitialize: true,
    validationSchema: validateSchema,
    onSubmit: async (values, {setSubmitting}) => {
      const config = {cancelToken: newCancelToken()}
      try {
        setSubmitting(true)
        const res = await A1BatchService.updateA1Batch(id, {name: values.name}, config)
        if (res) {
          onSuccess?.(values.name)
          toast.success(intl.formatMessage({id: 'RENAMED_A1_BATCH_SUCCESSFULLY'}))
          handleCloseModal()
        }
      } catch (error: any) {
        if (isCancel(error)) return
        onError?.(error?.response)
      } finally {
        setSubmitting(false)
      }
    },
  })

  const onClickRename = () => {
    if (disabled) return
    setShowModal(true)
  }

  return (
    <>
      <div
        className={clsx(className, {'cursor-no-drop opacity-50': disabled})}
        onClick={onClickRename}
      >
        {intl.formatMessage({id: 'RENAME_A1_BATCH'})}
      </div>
      {showModal && (
        <ModalTemplate
          id='gori_modal_rename_a1_batch'
          title={'RENAME_A1_BATCH'}
          show={showModal}
          handleClose={handleCloseModal}
          onClickPrimaryBtn={() => formik.handleSubmit()}
          loadingPrimaryBtn={formik.isSubmitting}
          disabledSecondaryBtn={formik.isSubmitting}
          dialogClassName='modal-size-md h-auto'
          contentClassName='modal-padding'
        >
          <h3 className='fw-bolder fs-4'>
            {intl.formatMessage({id: 'GIVE_A_UNIQUE_NAME_FOR_YOUR_A1_BATCH'})}:
          </h3>
          <InputTextFormik
            className='w-75'
            labelClassName='form-label'
            required
            formik={formik}
            name='name'
            placeholder='100000'
          />
        </ModalTemplate>
      )}
    </>
  )
}
